import { render, staticRenderFns } from "./AdRule.vue?vue&type=template&id=6ca7d972&scoped=true"
import script from "./AdRule.vue?vue&type=script&lang=js"
export * from "./AdRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca7d972",
  null
  
)

export default component.exports